import { Log, UserManager } from 'oidc-client-ts';
import { config } from '../../config';

export const handleLoginRedirect = async () => {
    // Login redirects that do not happen in an iframe are handled in the main app.
    // See doSignIn() in src/configuration/setup/oauth.ts
    Log.setLogger(console);
    Log.setLevel(Log.INFO);

    // Notify the parent window of response (callback) from the authorization endpoint.
    // Only a minimal usermanager is required here.
    const userManager = new UserManager({
        authority: `${config.login.authority}`,
        client_id: `${config.login.clientId}`,
        redirect_uri: `${config.login.redirectUri}`,
    });

    await userManager.signinCallback();
};
